import React, { useEffect, useState } from 'react';
import TreeView from 'react-treeview';
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../components/helpers/Translator';
import ProcessEdit from './ProcessEdit';
import ProcessDelete from './ProcessDelete';

export default function ProcessLayer({ process, collapsed, parentID }) {
  const [collapsedState, setCollapsedState] = useState(collapsed || true);
  const [showEditModal, setShowEditModal] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState();

  useEffect(() => {
    if (collapsed === false) setCollapsedState(collapsed);
    else setCollapsedState(true);
  }, [collapsed]);

  return (
    <>
      <TreeView
        nodeLabel={
          <div className="ml-2 marked d-inline-flex align-items-center">
            <div>
              <AppRemixIcon
                icon="edit-2"
                title={ReactDOMServer.renderToString(
                  <Translator file="general" name="general.edit" />
                )}
                className="border pointer"
                onClick={() => setShowEditModal(parentID ? 'subprocess' : 'process')}
              />
              <AppRemixIcon
                icon="delete-bin-6"
                title={ReactDOMServer.renderToString(
                  <Translator file="general" name="general.delete" />
                )}
                className="border pointer"
                onClick={() => setShowDeleteModal(parentID ? 'subprocess' : 'process')}
              />
            </div>
            <span className="ml-2 mr-2">{`${process.shortName} - ${process.name}`}</span>
          </div>
        }
        collapsed={collapsedState}
        onClick={() => setCollapsedState(!collapsedState)}
      >
        {process.subProcesses?.map((sp) => (
          <ProcessLayer
            key={sp.id}
            id={sp.id}
            process={sp}
            parentID={process?.id}
            collapsed={collapsed}
          />
        ))}
      </TreeView>
      <ProcessEdit
        id={process.id}
        parentID={parentID}
        process={process}
        showModal={showEditModal}
        setShowModal={setShowEditModal}
      />
      <ProcessDelete
        id={process.id}
        process={process}
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
      />
    </>
  );
}
